import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import { useReadChannelPlayerBaseInfo } from '@/scenarios/legacy-player/components/channel-player/hooks/use-read-channel-player-base-info';
import { transformImage } from '@/shared/lib/images';

import { SessionStopWithScreenProps } from './SessionStop.types';
import { useSessionStopped } from './hooks/useSessionStopped/useSessionStopped';
import { usePauseOnSessionStopped } from './hooks/usePauseOnSessionStopped';
import { useForcePlayerPause } from './hooks/useForcePlayerPause';
import { useSessionResume } from './hooks/useSessionResume';
import { SessionStopScreen } from './SessionStopScreen';
import { useActivityTracker } from './hooks/useActivityTracker';

export const SessionStopWithScreen: React.FC<SessionStopWithScreenProps> = ({
    contentId,
    playingState,
    play,
    pause,
    onIsSessionStoppedChanged,
}) => {
    const { sessionStopped, reset } = useSessionStopped(playingState);

    useActivityTracker({ sessionStopped, reset });

    usePauseOnSessionStopped(pause, sessionStopped);

    useForcePlayerPause(pause, sessionStopped, playingState);

    const resume = useSessionResume(play, { sessionStopped, reset });

    const baseInfo = useReadChannelPlayerBaseInfo(contentId);
    const title = baseInfo?.title;
    const channelLogoUrl = transformImage(baseInfo?.gallery.logos.main);

    useEffect(() => {
        onIsSessionStoppedChanged?.(sessionStopped);
    }, [onIsSessionStoppedChanged, sessionStopped]);

    if (sessionStopped) {
        return (
            <SessionStopScreen
                channelTitle={title}
                channelLogoUrl={channelLogoUrl}
                message={
                    <FormattedMessage
                        id="components.SessionStop.321ca4129abb40478ebb798a11589655"
                        defaultMessage="The video stopped because you had been inactive for a long time"
                        description="Текст сообщения о том, что просмотр остановлен"
                    />
                }
                onClick={resume}
            />
        );
    }

    return null;
};
